import MobileExport from '../Export/MobileExport';
import CustomFilter from './CustomFilter';

const MobileFilters: React.FC = () => {
  return (
    <>
      <CustomFilter />
      <MobileExport />
    </>
  );
};
export default MobileFilters;
